import { CloseIcon } from '@chakra-ui/icons'
import { Center, Flex, IconButton, Text } from '@chakra-ui/react'
import { isConsentForm } from '@hb/shared'
import { useEffect, useMemo, useRef } from 'react'
import { useFormState } from 'react-final-form'
import { useDocumentForm } from './context'

const DocumentFormTerms = () => {
  const { width: containerWidth, height: containerHeight, setTermsOpen } = useDocumentForm()
  const { width, height } = useMemo(
    () => ({
      width: Math.min(700, containerWidth * 0.95),
      height: Math.min(800, containerHeight * 0.95),
    }),
    [containerHeight, containerWidth],
  )
  return (
    <Flex
      w={`${width}px`}
      bg="white"
      borderRadius={6}
      userSelect="none"
      p={3}
      maxHeight={`${height}px`}
      flexFlow="column">
      <Flex align="center" w="100%" justify="space-between">
        <Text fontWeight={500} fontFamily="Hero-New">
          Electronic Signature Terms
        </Text>
        <IconButton
          aria-label="Close"
          borderRadius="full"
          size="xs"
          onClick={() => setTermsOpen(false)}
          icon={<CloseIcon />}
        />
      </Flex>
      <Text>
        I acknowledge that by entering my name in this form, I am providing my electronic signature,
        which is the legal equivalent of my handwritten signature on this document. I consent to be
        legally bound by the terms and conditions of this agreement and understand that this is a
        valid and enforceable electronic signature. I am also confirming that I am authorized to
        enter into this agreement.
      </Text>
    </Flex>
  )
}

export const DocumentFormTermsModal = () => {
  const { setTermsOpen, termsOpen, document } = useDocumentForm()

  const { valid } = useFormState({ subscription: { valid: true } })

  const wasValid = useRef(valid)
  useEffect(() => {
    if (!document || !isConsentForm(document)) return
    if (valid && !wasValid.current && !document.signedOn) {
      setTermsOpen(true)
    }
    wasValid.current = valid
  }, [valid, setTermsOpen, document])

  return (
    <Center
      position="absolute"
      opacity={termsOpen ? 1 : 0}
      alignItems="flex-end"
      pb={4}
      px={4}
      zIndex={3}
      pointerEvents={termsOpen ? 'auto' : 'none'}
      transition="opacity 0.3s ease-in-out"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="rgba(0,0,0,0.5)">
      <DocumentFormTerms />
    </Center>
  )
}
